import React, { useState } from 'react';
import { Button } from '../util/buttons';
import { Table } from '../util';
import { useTranslation } from 'react-i18next';
import { createTimezonedDate } from '../util/date';
import FolderFileIcon from './FolderFileIcon';
import { useGetFoldersAndFiles } from '../services/folders_and_files.service';
const FolderAndFilePicker = _ref => {
  let {
    // the root most accessible folder under a claim group for a client - we may not want them to access all folders in a claim group
    // The "Client Uploads" folder for the UK.
    claimGroupRootClientAccessableFolderId = null,
    targetModelId,
    type,
    modelName,
    selectedItem,
    onSelect,
    alreadySelectedFolderIds = [],
    alreadySelectedFileIds = []
  } = _ref;
  const [folderId, setFolderId] = useState(type === 'ClaimGroup' ? claimGroupRootClientAccessableFolderId : null);
  const [,,,, folders, files, currentPath] = useGetFoldersAndFiles(targetModelId, type, folderId);
  const shouldDisplayRootClaimGroupFolderBreadcrumb = !(type === 'ClaimGroup' && claimGroupRootClientAccessableFolderId);
  const {
    t
  } = useTranslation();
  const selectedFolderIds = new Set(alreadySelectedFolderIds);
  const selectedFileIds = new Set(alreadySelectedFileIds);
  const isSelected = (itemType, item) => selectedItem?.type === itemType && selectedItem?.item?.id === item.id;
  const renderSelectButton = (itemType, item, isAlreadySelected) => /*#__PURE__*/React.createElement(Button, {
    variant: isSelected(itemType, item) ? 'primary' : 'outline-primary',
    icon: "check",
    disabled: isAlreadySelected,
    onClick: () => onSelect({
      type: itemType,
      item
    })
  }, t(isAlreadySelected ? 'already_selected' : 'select'));
  const rows = [...folders.map(folder => {
    const isAlreadySelected = selectedFolderIds.has(folder.id);
    return {
      key: `folder-${folder.id}`,
      className: isSelected('folder', folder) ? 'table-primary' : '',
      columns: [/*#__PURE__*/React.createElement(FolderFileIcon, {
        isFile: false
      }), folder.created_at ? createTimezonedDate(folder.created_at).toCustomLocaleDateString() : '', /*#__PURE__*/React.createElement(Button, {
        variant: "link",
        className: "p-0",
        onClick: () => setFolderId(folder.id)
      }, folder.name), t('folder'), renderSelectButton('folder', folder, isAlreadySelected)]
    };
  }), ...[...files].sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map(file => {
    const isAlreadySelected = selectedFileIds.has(file.id);
    return {
      key: `file-${file.id}`,
      className: isSelected('file', file) ? 'table-primary' : '',
      columns: [/*#__PURE__*/React.createElement(FolderFileIcon, {
        isFile: true,
        contentType: file?.download_link?.content_type
      }), file.created_at ? createTimezonedDate(file.created_at).toCustomLocaleDateString() : '', file.name, t('file'), renderSelectButton('file', file, isAlreadySelected)]
    };
  })];
  const folderPathItems = currentPath.filter(pathItem => pathItem.id);
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, shouldDisplayRootClaimGroupFolderBreadcrumb && /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    className: "p-0",
    onClick: () => setFolderId(null)
  }, modelName), folderPathItems.map(pathItem => /*#__PURE__*/React.createElement(React.Fragment, {
    key: `folder-path-${pathItem.id}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "px-2"
  }, '>'), /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    className: "p-0",
    onClick: () => setFolderId(pathItem.id)
  }, pathItem.name)))), /*#__PURE__*/React.createElement(Table, {
    showControls: false,
    headers: [{
      text: ''
    }, {
      text: t('date')
    }, {
      text: t('name')
    }, {
      text: t('type')
    }, {
      text: ''
    }],
    rows: rows
  }));
};
export default FolderAndFilePicker;